module.exports = __webpack_public_path__ + "home/en-US/images/pinterest-7be5ff2736e176c07f68ffe721edab1a.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/pinterest.png
// module id = XoP0
// module chunks = 0